import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { AdjustStockInput } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { STOCK_LEVELS_QUERY_KEY } from './useStockLevels';
import { STOCK_TRANSACTIONS_QUERY_KEY } from './useStockTransactions';
import { LOW_STOCK_ITEMS_QUERY_KEY } from './useLowStockItems';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useAdjustStock = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['stock', 'adjust'],
    mutationFn: async (input: AdjustStockInput) => {
      return await warehouseService.adjustStock(input);
    },
    onSuccess: () => {
      toast.success(tActionMessages.stockAdjustedSuccessfully);
      queryClient.invalidateQueries({ queryKey: STOCK_LEVELS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: STOCK_TRANSACTIONS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: LOW_STOCK_ITEMS_QUERY_KEY });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, 'Failed to adjust stock'));
    },
  });
};

export default useAdjustStock;
